import { Language } from 'store/slices/language-slice';

interface ProfileMessages {
  seo: {
    title: string;
    description: string;
    keywords: string;
  };
  customerPending: {
    modalAlt: string;
    error: string;
    modalPortfolioCrypto: string;
    walletSuccessHeading: string;
    walletSuccessSubHeading: string;
    walletSuccessBlock: string;
    walletBackToProfile: string;
  };
  loginMethod: {
    title: string;
    subTitle: string;
    email: string;
    emailDescription: string;
    google: string;
    googleDescription: string;
    apple: string;
    appleDescription: string;
    modalPreAuthDescription: (authProvider: string) => string;
    modalPostAuthDescription: (authProvider: string) => string;
    submitText: string;
    secondaryText: string;
    loginWithProvider: (providerName: string) => string;
    keepUsingLoginMethod: (providerName: string) => string;
    loginMethodUpdated: string;
  };
}

type Message = {
  [key in Language]: ProfileMessages;
};

const messages: Message = {
  en: {
    seo: {
      title: 'Altify - Profile',
      description:
        'Effortlessly invest in crypto with one of our Bundles. Investing has never been this easy.',
      keywords:
        'investing, investment platform, cryptocurrency, top 10 cryptocurrency, top cryptocurrency, top performing crypto, diversification, diversified investing',
    },
    customerPending: {
      error: 'Token is no longer valid',
      modalAlt: 'token-not-valid',
      modalPortfolioCrypto: 'Back to portfolio',
      walletSuccessHeading: 'Update successful',
      walletSuccessSubHeading:
        'Your Bitcoin withdrawal address has been successfully updated.',
      walletSuccessBlock:
        'You will be able to make withdrawals to this address in 24 hours after the cooling off period.',
      walletBackToProfile: 'Back to profile',
    },
    loginMethod: {
      title: 'Login Method',
      subTitle: 'Choose your preferred login method',
      email: 'Email',
      loginMethodUpdated: 'Login method updated',
      emailDescription: 'Log in with an email and password',
      google: 'Google account',
      googleDescription: 'Log in with your Google account',
      apple: 'Apple account',
      appleDescription: 'Log in with your Apple account',
      submitText: 'Got it',
      secondaryText: 'Need help?',
      modalPreAuthDescription: (
        authProvider: string,
      ) => `To log in with your <strong>${authProvider}</strong>, you’ll need to authorise this change.
<br />
<br />
You can update your log in method in the Profile section of the Altify app or web app at any time.
<br />
<br />
Note: changing your login method will disable withdrawals from your account for 24 hours.`,
      modalPostAuthDescription: (
        authProvider: string,
      ) => `You’ve successfully updated your login method to use your <b>${authProvider}</b>.
            <br />
            <br />

To log in to your account, select “Log in with <strong>${authProvider}</strong>".
<br />
<br />

To change your login method, navigate to “Account” in the your Profile section of the Revix mobile or web app.`,
      loginWithProvider: (providerName: string) =>
        `Log in with ${providerName}`,
      keepUsingLoginMethod: (providerName: string) =>
        `Keep using ${providerName}`,
    },
  },
};

export default messages;
